// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as RestApi$DvmAdminFrontendFr from "../../../../api/RestApi.bs.js";
import * as App_TopMenu_Notifications_Types$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Types.bs.js";

function fetchNotifications(userManager, setResult, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", App_TopMenu_Notifications_Types$DvmAdminFrontendFr.notifications_decode, undefined, userManager, selectedRole, "/notification").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var searchTable = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: searchTable
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function dismissNotification(userManager, setResult, selectedRole, notificationType, messageType, detail) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("DELETE", undefined, userManager, selectedRole, "/notification?notificationType=" + App_TopMenu_Notifications_Types$DvmAdminFrontendFr.NotificationType.toString(notificationType) + "" + Belt_Option.mapWithDefault(messageType, "", (function (x) {
                return "&messageType=" + App_TopMenu_Notifications_Types$DvmAdminFrontendFr.MessageType.toString(x) + "";
              })) + "" + Belt_Option.mapWithDefault(detail, "", (function (x) {
                return "&detail=" + x + "";
              })) + "").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var searchTable = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: searchTable
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

export {
  fetchNotifications ,
  dismissNotification ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
